module.exports = __webpack_public_path__ + "img/logo.37d2efd3.svg";